import { AxiosError, AxiosResponse } from 'axios';
import {
  HTTP_STATUS_CODE_OK,
  V2_FIND_MEMBER_DATA_ENDPOINT,
  V2_GET_MEMBER_DATA_ENDPOINT,
  V2_PATCH_MEMBER_DATA_ENDPOINT,
} from '../constants';
import { Contact } from '../models/address';
import { Member } from '../models/member';
import axiosPrivate from '../models/axios/axios-private';
import { getEndpointResponse } from '../utils/endpoint-response';
import { HttpRequestResponse } from '../models/web/http-request-response';
import {
  buildContactPatchOperations,
  buildLinkMemberPatchOperation,
} from '../utils/member-json-patch';

export const updateMemberData = async (
  memberId: string,
  original: Member,
  contactUpdates: Partial<Contact>
): Promise<HttpRequestResponse<void>> => {
  const updatedContact: Contact = { ...original.contact, ...contactUpdates };
  const patchDocument = buildContactPatchOperations(memberId, original.contact, updatedContact);

  if (patchDocument.length === 0) {
    return {
      message: '',
      statusCode: HTTP_STATUS_CODE_OK,
      response: null,
      isSuccessful: true,
    };
  }

  const url = V2_PATCH_MEMBER_DATA_ENDPOINT.replace('{MemberId}', memberId);
  const response: AxiosResponse | AxiosError = await axiosPrivate
    .patch(url, patchDocument)
    .catch((err: AxiosError): AxiosError => err);

  return getEndpointResponse(response);
};

export const linkMemberToUser = async (
  memberId: string,
  userId: string
): Promise<AxiosResponse> => {
  const url = V2_PATCH_MEMBER_DATA_ENDPOINT.replace('{MemberId}', memberId);
  return axiosPrivate.patch(url, buildLinkMemberPatchOperation(userId));
};

export const getMember = async (
  memberId: string
): Promise<HttpRequestResponse<Member | null>> => {
  const url = V2_GET_MEMBER_DATA_ENDPOINT.replace('{MemberId}', memberId);
  const response: AxiosResponse | AxiosError = await axiosPrivate
    .get<Member>(url)
    .catch((err: AxiosError): AxiosError => err);

  return getEndpointResponse(response);
};

export interface FindMemberParams {
  memberNumber?: number;
  documentNumber?: number;
  fullName?: string;
}

export const findMember = async (params: FindMemberParams): Promise<HttpRequestResponse<Member>> => {
  const response: AxiosResponse | AxiosError = await axiosPrivate
    .get<Member>(V2_FIND_MEMBER_DATA_ENDPOINT, { params })
    .catch((err: AxiosError): AxiosError => err);

  return getEndpointResponse(response);
};
